import React from 'react';

import { style, media } from 'glamor';

type Props = {
  children: React.Element,
};

export default ({children}: Props) => (
  <div {...style({
    padding: '10px 20px',
  })} {...media('(min-width: 701px)', {
    padding: '10px 7.5vw',
  })}>{children}</div>
);



// WEBPACK FOOTER //
// ../src/client/components/layout/Container.js